export class OpenAuthenticationModel {
  client_id : string;
  client_secret: string;
  code: string;
  redirect_uri : string;

}
